import { render, staticRenderFns } from "./UsuarioFormSection.vue?vue&type=template&id=67ef5479&scoped=true"
import script from "./UsuarioFormSection.vue?vue&type=script&lang=js"
export * from "./UsuarioFormSection.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFormSection.vue?vue&type=style&index=0&id=67ef5479&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ef5479",
  null
  
)

export default component.exports